import '@/modules/global';
import { Header, StickyHeader } from '@/modules/header';
import PredictiveSearch from '@/modules/predictive-search';
import CartNotification from '@/modules/cart-notification';
import CartCrossSellCarousel from '@/modules/cart-cross-sell-carousel';
import ResponsiveVideo from '@/modules/responsive-video';
import LazyVideo from '@/modules/lazy-video';
import FeaturedCollectionsSlider from '@/modules/featured-collections'
import MediaGridSlider from '@/modules/media-grid'
import PortraitVideoSwiper from '@/modules/portrait-video-swiper';
import ProductCarousel from '@/modules/product-carousel'
import ProductCategoryCarousel from '@/modules/product-category-carousel';
import NewsCarousel from '@/modules/news-carousel'
import HalfWidthCarousel from '@/modules/half-width-carousel'
import MediaCarousel from '@/modules/media-carousel'
import LogoGrid from '@/modules/logo-grid'
import FeaturedIconCarousel from '@/modules/featured-icon-carousel';
import AnnouncementCarousel from '@/modules/announcement-carousel';
import TabbedMediaContent from '@/modules/tabbed-media-content';
import CardCarousel from '@/modules/card-carousel';
import SquareMediaContentGrid from '@/modules/square-media-content-grid';
import IngredientsTimeline from '@/modules/ingredients-timeline';
import { FeaturedProductListContentSwap } from '@/modules/featured-product-list';
import { Ticker } from '@/modules/ticker';
import ProductCarouselToggle from '@/modules/product-carousel-toggle';
import CollectionBannerCarousel from '@/modules/collection-banner-carousel';

import { BeforeAndAfterCarousel, BeforeAndAfterToggle } from '@/modules/before-and-after';

import { MediaScale } from '@/modules/animation';
import '@/modules/accordion';
import KeyboardFocus from '@/modules/keyboard-focus/keyboard-focus';

const responsiveVideos = document.querySelectorAll('.js-responsive-video');
if (responsiveVideos) {
    Array.from(responsiveVideos).forEach(el => new ResponsiveVideo(el));
}

const lazyVideos = document.querySelectorAll('.js-lazy-video');
if (lazyVideos) {
    new LazyVideo(lazyVideos);
}

new Header();

if (document.getElementsByTagName('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

if (document.getElementsByTagName('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}

if (document.getElementsByTagName('cart-notification')) {
    customElements.define('cart-notification', CartNotification);
}

const cartCrossSellCarousels = document.querySelectorAll('.js-cart-cross-sell-carousel');
if (cartCrossSellCarousels) {
    cartCrossSellCarousels.forEach(el => new CartCrossSellCarousel(el));
}

const collectionSliders = document.querySelectorAll('.js-featured-collections-slider');
if (collectionSliders) {
    collectionSliders.forEach(el => new FeaturedCollectionsSlider(el));
}

const mediaGridSliders = document.querySelectorAll('.js-media-grid-slider');
if (mediaGridSliders) {
    mediaGridSliders.forEach(el => new MediaGridSlider(el));
}

const productSliders = document.querySelectorAll('.js-product-carousel');
if (productSliders) {
    productSliders.forEach(el => new ProductCarousel(el));
}

const portraitVideoSwiper = document.querySelectorAll('.js-portrait-video-carousel');
if (portraitVideoSwiper) {
    portraitVideoSwiper.forEach(el => new PortraitVideoSwiper(el));
}

const productCategorySliders = document.querySelectorAll('.js-product-category-carousel');
if (productCategorySliders) {
    productCategorySliders.forEach(el => new ProductCategoryCarousel(el));
}

const newsSliders = document.querySelectorAll('.js-news-carousel');
if (newsSliders) {
    newsSliders.forEach(el => new NewsCarousel(el));
}

const halfWidthCarousel = document.querySelectorAll('.js-half-width-carousel');
if (halfWidthCarousel) {
    halfWidthCarousel.forEach(el => new HalfWidthCarousel(el));
}

const mediaCarousel = document.querySelectorAll('.js-media-carousel');
if (mediaCarousel) {
    mediaCarousel.forEach(el => new MediaCarousel(el));
}

const logoGrid = document.querySelectorAll('.js-logo-grid');
if (logoGrid) {
    logoGrid.forEach(el => new LogoGrid(el));
}

const featuredIconsSliders = document.querySelectorAll('.js-featured-icons-carousel');
if (featuredIconsSliders) {
    featuredIconsSliders.forEach(el => new FeaturedIconCarousel(el));
}

const announcementCarousels = document.querySelectorAll('.js-announcement-carousel');
if (announcementCarousels) {
    announcementCarousels.forEach(el => new AnnouncementCarousel(el));
}

const tabbedContentCarousels = document.querySelectorAll('.js-tabbed-media-content');
if (tabbedContentCarousels) {
    tabbedContentCarousels.forEach(el => new TabbedMediaContent(el));
}

const cardCarousels = document.querySelectorAll('.js-card-carousel');
if (cardCarousels) {
    cardCarousels.forEach(el => new CardCarousel(el));
}

const squareMediaContentGrid = document.querySelectorAll('.js-square-media-content-grid');
if (squareMediaContentGrid) {
    squareMediaContentGrid.forEach(el => new SquareMediaContentGrid(el));
}

const ingredientsTimelines = document.querySelectorAll('.js-ingredients-timeline');
if (ingredientsTimelines) {
    ingredientsTimelines.forEach(el => new IngredientsTimeline(el));
}

const featuredProductListContentSwaps = [...document.querySelectorAll('.js-featured-product-list-content-swap')];
if (featuredProductListContentSwaps.length) {
    featuredProductListContentSwaps.forEach(el => new FeaturedProductListContentSwap(el));
}

const tickers = [...document.querySelectorAll('.js-ticker')];
if (tickers.length) {
    tickers.forEach(el => new Ticker(el));
}

const productToggleSliders = document.querySelectorAll('.js-product-carousel-toggle');
if (productToggleSliders) {
    productToggleSliders.forEach(el => new ProductCarouselToggle(el));
}

const collectionBannerCarousels = document.querySelectorAll('.js-collection-banner-carousel');
if (collectionBannerCarousels) {
    collectionBannerCarousels.forEach(el => new CollectionBannerCarousel(el));
}

if ([...document.querySelectorAll('.js-before-and-after-carousel')].length) {
    [...document.querySelectorAll('.js-before-and-after-carousel')].forEach(item => new BeforeAndAfterCarousel(item));
}

if ([...document.querySelectorAll('.js-before-and-after-toggle')].length) {
    [...document.querySelectorAll('.js-before-and-after-toggle')].forEach(item => new BeforeAndAfterToggle(item));
}

new MediaScale();
new KeyboardFocus();
